







































import Vue, { PropType } from 'vue';
import ImageShow from '@/dex-shared/components/new_content/show/ImageShow.vue';
import CorrectionAnnotation from '@/components/correction/CorrectionAnnotation.vue';
import ImageModel from '@/dex-shared/models/ImageModel';
import AnnotationModel from '@/dex-shared/models/AnnotationModel';

export default Vue.extend({
  components: {
    ImageShow,
    CorrectionAnnotation,
  },
  props: {
    image: {
      type: Object as PropType<ImageModel>,
      required: true,
    },
    annotations: {
      type: Array as PropType<AnnotationModel[]>,
      required: false,
      default: () => [],
    },
  },
});
